import React, { Component } from "react";
import Player from "./Player";
import Navbar from "./Navbar";
import Dropdown from "./Dropdown";
import { season1, season2, season3, season4 } from "./db";
import "./style.css";

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.match.params.id,
    };
  }

  componentDidMount() {
    console.log(this.state.id);
  }

  render() {
    return (
      <div className="main">
        <Navbar />
        <div className="vid-con">
          <Player id={this.state.id} />
          <div id="container-a4efe0cb21de64f79b85a3ec86ab6306"></div>
        </div>
        <br />
        <div className="tabs">
          <Dropdown season="1" episode={season1} />
          <Dropdown season="2" episode={season2} />
          <Dropdown season="3" episode={season3} />
          <Dropdown season="4" episode={season4} />
          <div className="tab">
            <input type="radio" id="rd5" name="rd" className="input-tag" />
            <label htmlFor="rd5" className="tab-close">
              Close &times;
            </label>
          </div>
          <div id="container-a4efe0cb21de64f79b85a3ec86ab6306"></div>
        </div>
        <br />
        <br />
      </div>
    );
  }
}

export default Main;
